var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthWellness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.61,109.8H136.13L128.61,124a3.26,3.26,0,0,1-2.88,1.73h-.19a3.25,3.25,0,0,1-2.84-2.09l-9.94-26-9.54,25.5a3.24,3.24,0,0,1-3,2.11,3.17,3.17,0,0,1-3.07-2L86,97l-4.53,10.59a3.23,3.23,0,0,1-3,2H57.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.07,194a3.3,3.3,0,0,1-2.59-1.26C93.16,178.23,81,166.38,70.31,155.91,48,134.07,28.65,115.21,28.65,83.48a39.53,39.53,0,0,1,39.91-39c18.8,0,31,16.29,38.49,26.85,7.47-10.56,19.71-26.85,38.51-26.85,15.17,0,24.62,7.17,29.88,13.18a40.49,40.49,0,0,1,10,25.83c0,31.74-19.32,50.61-41.68,72.45-10.7,10.46-22.84,22.31-34.16,36.84A3.23,3.23,0,0,1,107.07,194Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthWellness);
export default __webpack_public_path__ + "static/media/HEALTH_WELLNESS.b7e0c3f89df66aec28f39af2af04a290.svg";
export { ForwardRef as ReactComponent };